// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function References({ v }) {
  return (
    <section id="references" style={{ background: "#FFFFFF", borderTop: "1px solid #E3E5E8", borderBottom: "1px solid #E3E5E8" }}>
      <div className="m-sec" style={{ maxWidth: "1240px", margin: "0 auto", padding: "96px 24px", display: "flex", flexDirection: "column", gap: "28px" }}>
        <h2 style={{ margin: "0", fontSize: "clamp(32px, 3.4vw, 48px)", fontWeight: "800", fontStretch: "80%", lineHeight: "1.04" }}>
          Mes réalisations
        </h2>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>
          <article style={{ flex: "1.2 1 460px", minWidth: "0", padding: "28px", border: "1px solid #CDD1D6", borderRadius: "8px", display: "flex", flexDirection: "column", gap: "14px" }}>
            <p style={{ margin: "0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "12px", color: "#5A6068" }}>
              Bureau d'études · avec Deep Blue AI
            </p>
            <h3 style={{ margin: "0", fontSize: "26px", fontWeight: "800", fontStretch: "82%", lineHeight: "1.1" }}>
              Un rapport de 40 pages généré en quelques secondes
            </h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(140px, 100%), 1fr))", gap: "1px", background: "#E3E5E8", border: "1px solid #E3E5E8" }}>
              <div style={{ padding: "14px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "2px" }}>
                <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "18px", fontWeight: "600" }}>
                  3–4 h → secondes
                </span>
                <span style={{ fontSize: "12px", color: "#5A6068" }}>
                  par rapport
                </span>
              </div>
              <div style={{ padding: "14px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "2px" }}>
                <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "18px", fontWeight: "600" }}>
                  0
                </span>
                <span style={{ fontSize: "12px", color: "#5A6068" }}>
                  ressaisie à la main
                </span>
              </div>
              <div style={{ padding: "14px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "2px" }}>
                <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "18px", fontWeight: "600" }}>
                  ≈ 15 h
                </span>
                <span style={{ fontSize: "12px", color: "#5A6068" }}>
                  rendues par semaine
                </span>
              </div>
            </div>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              En e‑commerce, le même principe produit vos bons de commande, fiches produit ou inventaires.
            </p>
          </article>
          <div style={{ flex: "1 1 360px", minWidth: "0", display: "flex", flexDirection: "column", gap: "16px" }}>
            <figure style={{ margin: "0", padding: "22px", background: "#FBFBFA", border: "1px solid #E3E5E8", borderRadius: "8px", display: "flex", flexDirection: "column", gap: "10px" }}>
              <blockquote style={{ margin: "0", fontSize: "16px", fontStyle: "italic" }}>
                « Très bonne présentation professionnelle, il travaille sérieusement et dans le respect des délais. »
              </blockquote>
              <figcaption style={{ fontSize: "14px" }}>
                <strong>
                  Céline
                </strong>
                , Business Manager · Deep Blue AI
              </figcaption>
            </figure>
            <figure style={{ margin: "0", padding: "22px", background: "#FBFBFA", border: "1px solid #E3E5E8", borderRadius: "8px", display: "flex", flexDirection: "column", gap: "10px" }}>
              <blockquote style={{ margin: "0", fontSize: "16px", fontStyle: "italic" }}>
                « Très compétent techniquement, extrêmement réactif, un travail propre et fiable. Je recommande sans hésiter ! »
              </blockquote>
              <figcaption style={{ fontSize: "14px" }}>
                <strong>
                  Émilie
                </strong>
                , Dirigeante · Ascension Marketing
              </figcaption>
            </figure>
            <a href="https://www.malt.fr/profile/matteogalfre" style={{ alignSelf: "flex-start", display: "inline-flex", alignItems: "center", minHeight: "44px", fontWeight: "600" }}>
              Voir mes avis sur Malt
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
